import React, { useState } from 'react';
import axios from 'axios';
import { useWorkspace } from '../../../context/WorkspaceContext';
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const ThreadsLoginButton = () => {
    const { idToken } = useWorkspace();
    const [isLoading, setIsLoading] = useState(false);

    const handleAuthClick = () => {
        setIsLoading(true);
        axios.get(BACKEND_API_URL + '/api/threads/oauth', { headers: { Authorization: `Bearer ${idToken}` } })
            .then(response => {
                // Set pending auth flag
                localStorage.setItem('social_auth_pending', 'threads');
                window.open(response.data, '_blank');
                setIsLoading(false);
            })
            .catch(error => {
                console.error(error);
                setIsLoading(false);
            });
    };

    return (
        <button
            className="bg-black hover:bg-gray-800 h-[70px] p-4 rounded-lg flex items-center w-full justify-between"
            onClick={handleAuthClick}
            disabled={isLoading}
        >
            {isLoading ? 'Loading...' : (
                <>
                    <div className="mr-3 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                        <img
                            src={'../socials/threads-logo.svg'}
                            alt="Threads Logo"
                            className="w-8 h-8"
                        />
                    </div>
                    <p className="text-white font-bold">Threads</p>
                </>
            )}
            <div></div>
        </button>
    );
};

export default ThreadsLoginButton;
